import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { usePermissions } from "@/use/usePermissions";

import UiApp from "@/plugins/ui/components/app/UiApp.vue";
import UiAppbar from "@/plugins/ui/components/appbar/UiAppbar.vue";

import UiIconBtn from "@/components/ui/UiIconBtn.vue";

import AppSidebar from "@/components/AppSidebar.vue";
import AppTabbar from "@/components/AppTabbar.vue";
import QrAccess from "@/components/QrAccess.vue";

import AccountInfo from "@/features/home/components/AccountInfo.vue";
import AccountScore from "@/features/home/components/AccountScore.vue";
import LastNews from "@/features/home/components/LastNews.vue";
import LastOperations from "@/features/home/components/LastOperations.vue";
import LastAcsEvents from "@/features/home/components/LastAcsEvents.vue";
import QuickActions from "@/features/home/components/QuickActions.vue";
import MenuVoting from "@/features/home/components/MenuVoting.vue";

import DefaultPasswordWarning from "@/components/DefaultPasswordWarning.vue";
import AvailableModules from "@/components/AvailableModules.vue";
import { useStore } from "@/use/useStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

const { isAllow } = usePermissions();
const { currentUser } = useStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UiApp, null, {
    sidebar: _withCtx(() => [
      _createVNode(AppSidebar)
    ]),
    header: _withCtx(() => [
      _createVNode(UiAppbar, {
        temporary: "",
        title: "Главная"
      }, {
        right: _withCtx(() => [
          _createVNode(UiIconBtn, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.replace('/settings'))),
            variant: "tertiary",
            icon: "Cog"
          })
        ]),
        _: 1
      })
    ]),
    footer: _withCtx(() => [
      _createVNode(AppTabbar)
    ]),
    default: _withCtx(() => [
      _createVNode(AccountInfo, {
        "show-score-id": "",
        style: {"margin-bottom":"16px"}
      }),
      (_unref(isAllow)('score_sub') || _unref(isAllow)('score_limit') || _unref(isAllow)('pay'))
        ? (_openBlock(), _createBlock(AccountScore, { key: 0 }))
        : _createCommentVNode("", true),
      (_unref(currentUser)?.default_password)
        ? (_openBlock(), _createBlock(DefaultPasswordWarning, { key: 1 }))
        : _createCommentVNode("", true),
      (_unref(isAllow)('qr'))
        ? (_openBlock(), _createBlock(QrAccess, { key: 2 }))
        : _createCommentVNode("", true),
      (_unref(isAllow)('menu_voting'))
        ? (_openBlock(), _createBlock(MenuVoting, { key: 3 }))
        : _createCommentVNode("", true),
      (_unref(isAllow)('bot') || _unref(isAllow)('request'))
        ? (_openBlock(), _createBlock(QuickActions, { key: 4 }))
        : _createCommentVNode("", true),
      (_unref(isAllow)('news'))
        ? (_openBlock(), _createBlock(LastNews, { key: 5 }))
        : _createCommentVNode("", true),
      (_unref(isAllow)('acs'))
        ? (_openBlock(), _createBlock(LastAcsEvents, { key: 6 }))
        : _createCommentVNode("", true),
      (_unref(isAllow)('score_operation'))
        ? (_openBlock(), _createBlock(LastOperations, { key: 7 }))
        : _createCommentVNode("", true),
      _createVNode(AvailableModules, { type: "subscription" })
    ]),
    _: 1
  }))
}
}

})